import { render, staticRenderFns } from "./distributeBoardInfo.vue?vue&type=template&id=4dda77ab&"
import script from "./distributeBoardInfo.ts?vue&type=script&lang=ts&"
export * from "./distributeBoardInfo.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._dqvcgk3en6wwbxrhlb6nnpgame/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports